import moment from 'moment';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import app from '../../../libs/apiClient';
import { renderSearchSelect, renderDatePicker } from '../Utils/renderField/renderField';
import _ from 'lodash';


const Form = (props) => {

    const { handleSubmit, cancel, formValues } = props;

    const loadAirlines = (search) => {

        const params = { $paginate: false };
        if(search){
            params.$or = [
                { code: { $regex: _.escapeRegExp(search), $options: 'i' } },
                { company: { $regex: _.escapeRegExp(search), $options: 'i' } },
            ]
        }

        return app.service('/api/airline').find({
            query: params
        }).then(result => {
            for(let i = 0; i < result.length; i++)
                result[i].label = `${result[i].code} ${result[i].company}`;

            result.sort((a,b) => a.code.localeCompare(b.code));
            return { options: result };
        }).catch(error=>{
            console.log(error);
            return { options: []}
        })
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-12 mb-4">
                    <Field
                        name="customer"
                        component={renderSearchSelect}
                        loadOptions={loadAirlines}
                        placeholder="Select Customer"
                        valueKey="_id"
                        labelKey="label"
                        allKey
                    />
                </div>
                <div className="col-6 mt-3 form-group">
                    <Field
                        name="date"
                        component={renderDatePicker}
                        isOutsideRange={false}
                        numberOfMonths={1}
                        placeholder="Start Date"
                        className="p-0"
                    />
                </div>
                <div className="col-6 mt-3 form-group">
                    <Field
                        name="endDate"
                        component={renderDatePicker}
                        isOutsideRange={false}
                        numberOfMonths={1}
                        placeholder="End Date"
                        className="p-0"
                    />
                </div>
                <div className="col-12 d-flex justify-content-center pt-4">
                    <button type="submit" className="btn btn-primary btn-lg w-100">
                        VIEW
                    </button>
                </div>
            </div>
        </form>
    )
}

const CustomerForm = reduxForm({
    form: "customerForm",
    validate: (data) => {
        const errors = {};
        if (!data.customer) errors.customer = "Required Field";
        if (!data.date) errors.date = "Required Field";
        if (!data.endDate) errors.endDate = "Required Field";
        if (data.date && data.endDate) {
            if (data.date.isAfter(data.endDate)) {
                errors.date = "Invalid Start Date";
            }
        }
        return errors;
    }
})(Form);

export default CustomerForm;
